export default __webpack_public_path__ + "static/media/icon-hand-bag.10cb7e76.svg";